import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "20", height: "5", x: "2", y: "4", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 13v7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m9 16 3-3 3 3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 9v9a2 2 0 0 0 2 2h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 9v9a2 2 0 0 1-2 2h-2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArchiveRestore";
const ArchiveRestore = memo(themed(Icon));
export {
  ArchiveRestore
};
//# sourceMappingURL=archive-restore.js.map
